import React from 'react';
import '../../styles/modes/customMode.css';

const PathSegmentDetails = ({ customPath, connections, demand, modeCapacities }) => {
  if (customPath.length <= 1 || !demand || demand <= 0) return null;
  
  // Build segments from custom path
  const segments = [];
  for (let i = 0; i < customPath.length - 1; i++) {
    const fromPoint = customPath[i];
    const toPoint = customPath[i + 1];
    
    // Find matching connection
    const connection = connections.find(conn => 
      (conn.points[0]?.id === fromPoint.id && conn.points[1]?.id === toPoint.id) ||
      (conn.points[1]?.id === fromPoint.id && conn.points[0]?.id === toPoint.id)
    );
    
    if (connection) {
      const capacity = modeCapacities[connection.transportMode] || 0;
      
      segments.push({
        from: fromPoint.name || fromPoint.id,
        to: toPoint.name || toPoint.id,
        transport_mode: connection.transportMode,
        duration: connection.duration || 0,
        capacity: capacity,
        color: connection.color
      });
    }
  }
  
  if (segments.length === 0) return null;
  
  return (
    <div className="custom-path-segments">
      <div className="capacity-divider"></div>
      <p className="capacity-header"><strong>Capacity Analysis:</strong></p>
      
      <div className="route-segments-info">
        {segments.map((segment, idx) => {
          const tripsNeeded = segment.capacity > 0 ? Math.ceil(demand / segment.capacity) : 0;
          const segmentTotalTime = segment.duration * tripsNeeded;
          
          return (
            <div key={idx} className="segment-card">
              <div className="segment-title">
                <span className="segment-route">{segment.from} → {segment.to}</span>
                <span className="transport-mode-badge">{segment.transport_mode}</span>
              </div>
              
              <div className="segment-info-grid">
                <div className="info-item">
                  <span className="info-label">Single Trip Time:</span>
                  <span className="info-value">{segment.duration}h</span>
                </div>
                <div className="info-item">
                  <span className="info-label">Trips Needed:</span>
                  <span className="info-value">{tripsNeeded || 'Set capacity'}</span>
                </div>
                <div className="info-item">
                  <span className="info-label">Segment Total Time:</span>
                  <span className="info-value-highlight">{segmentTotalTime > 0 ? `${segmentTotalTime}h` : 'N/A'}</span>
                </div>
                <div className="info-item">
                  <span className="info-label">Capacity per Trip:</span>
                  <span className="info-value">{segment.capacity > 0 ? `${segment.capacity} units` : 'Not set'}</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PathSegmentDetails;

